import { Col, Flex, FloatButton, Row } from "antd";
import { useEffect, useState } from "react";
import { HiChatBubbleLeft } from "react-icons/hi2";
import { AccountSetup } from "../../components/accountSetup";
import { DashboardAskAI } from "../../components/dashboard/DashboardAskAI";
import { DashboardCripto } from "../../components/dashboard/DashboardCripto";
import { DashboardHeader } from "../../components/dashboard/DashboardHeader";
import { DashboardHealthMetrics } from "../../components/dashboard/DashboardHealthMetrics";
import { DashboardKnow } from "../../components/dashboard/DashboardKnow";
import { DashboardSpotify } from "../../components/dashboard/DashboardSpotify";
import DashboardWikipedia from "../../components/dashboard/DashboardWikipedia";
import { DashboardYourTeam } from "../../components/dashboard/DashboardYourTeam";
import { useToken } from "../../hooks/useToken";
import { EIntegrationPlatform } from "../../models/integrations.model";
import { TPostAd } from "../../models/posts.model";
import { useAI } from "../../providers/AIProvider";
import {
  IntegrationList,
  useIntegrations,
} from "../../providers/IntegrationsProvider";
import { getUserProfile } from "../../services/users.service";

export function Dashboard() {
  const { token, screens } = useToken();
  const [isCreatingAccount, setCreatingAccount] = useState<boolean>(false);
  const [postAd, setPostAd] = useState<TPostAd>({
    // ... (seu estado postAd mantido)
    id: "ticketmaster",
    type: "CARD",
    title: "Wicked",
    description:
      "The Broadway sensation, looks at what happened in the Land of Oz…but from a different angle.  Long before Dorothy arrives, there is another girl, born with emerald-green skin—smart, fiery, misunderstood, and possessing an extraordinary talent. When she meets a bubbly blonde who is exceptionally popular, their initial rivalry turns into the unlikeliest of friendships…until the world decides to call one “good,” and the other one “wicked.”",
    image:
      "https://s1.ticketm.net/dam/a/8f4/eac77d3f-de25-40f5-af88-00ea8c1568f4_91951_RETINA_PORTRAIT_3_2.jpg",
    ctaLink:
      "https://www.ticketmaster.com/wicked-touring-tickets/artist/864373",
    ctaTitle: "Buy tickets",
    sponsor: {
      name: "Ticketmaster",
      logo: "http://uk.tmconst.com/production-1-174-1-10656786/images/favicon.ico",
      website: "https://www.ticketmaster.com/",
    },
  });
  const { integrations } = useIntegrations();
  const { setUseAI } = useAI();

  useEffect(() => {
    getUserProfile({
      onSuccess: (data) => {
        if (!data.isOnboardingDone) {
          setCreatingAccount(true);
        }
      },
      onError: () => {
        setCreatingAccount(true);
      },
    });

    // getPostAd({
    //   onSuccess: (data) => setPostAd(data.content[0]),
    // });
  }, []);

  // --- Calcula a altura disponível para a área de conteúdo ---
  // Ajuste o '177px' se a altura do seu Header + outros elementos fixos for diferente
  const contentHeight = `calc(100vh - 177px)`;

  return (
    <>
      {isCreatingAccount && (
        <AccountSetup onClose={() => setCreatingAccount(false)} />
      )}
      <DashboardHeader />

      {IntegrationList.map((integration) => {
        // Mantendo sem key, como no original
        return <integration.AuthRender />;
      })}

      <div
        style={{
          padding: token.paddingLG,
          width: "100%",
          height: contentHeight,
        }}
      >
        <Row gutter={[24, 24]} style={{ height: "100%" }}>
          {screens.xxl && (
            <Col
              span={6}
              xl={5}
              xxl={4}
              style={{ height: "100%", overflowY: "auto" }}
            >
              <DashboardHealthMetrics />
            </Col>
          )}

          {screens.xl && (
            <Col
              span={6}
              xl={8}
              xxl={7}
              style={{
                height: "100%",
                overflowY: "auto",
                background: "transparent",
              }}
            >
              <DashboardYourTeam />
            </Col>
          )}

          {screens.xl && (
            <Col span={6} xl={8} xxl={7} style={{ height: "100%", overflowY: "auto" }}>
              <Row gutter={[24, 24]}>
                {integrations.some(
                  (integration) =>
                    integration.platform == EIntegrationPlatform.WIKIPEDIA
                ) && (
                  <Col span={24}>
                    <DashboardWikipedia />
                  </Col>
                )}
                <Col span={24}>
                  <DashboardKnow />
                </Col>
                {integrations.some(
                  (integration) =>
                    integration.platform == EIntegrationPlatform.SPOTIFY
                ) && (
                  <Col md={24}>
                    <DashboardSpotify />
                  </Col>
                )}
                <Col span={24}>
                  <DashboardCripto />
                </Col>
              </Row>
            </Col>
          )}

          {!screens.xl && (
            <Col
              span={24}
              md={14}
              lg={14}
              style={{ height: "100%", overflowY: "auto" }}
            >
              <Row gutter={[24, 24]}>
                {integrations.some(
                  (integration) =>
                    integration.platform == EIntegrationPlatform.WIKIPEDIA
                ) && (
                  <Col span={24}>
                    <DashboardWikipedia />
                  </Col>
                )}
                <Col span={24}>
                  <DashboardKnow />
                </Col>
                {integrations.some(
                  (integration) =>
                    integration.platform == EIntegrationPlatform.SPOTIFY
                ) && (
                  <Col span={24}>
                    <DashboardSpotify />
                  </Col>
                )}
                <Col span={24}>
                  <DashboardCripto />
                </Col>
                <Col
                  span={24}
                  style={{
                    background: "transparent",
                  }}
                >
                  <DashboardYourTeam />
                </Col>
              </Row>
            </Col>
          )}

          {screens.md && (
            <Col span={10} lg={10} xl={8} xxl={6}>
              <Flex
                style={{
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <DashboardAskAI />
              </Flex>
            </Col>
          )}

          {!screens?.sm && (
            <FloatButton
              style={{
                background:
                  "linear-gradient(103.37deg, #854eca 10.17%, #10b981 52.77%, #eccc00 74.07%, #ee7a00 95.37%)",
                border: "none",
                color: "white",
                right: 24,
                bottom: 24,
              }}
              onClick={() => setUseAI(true)}
              icon={<HiChatBubbleLeft />}
            />
          )}
        </Row>
      </div>
    </>
  );
}
